export default __webpack_public_path__ + "static/media/EngineeringCanals_04.899b6f2a.png";